export var SystemFeatureToggle;
(function (SystemFeatureToggle) {
    SystemFeatureToggle["DEBUG"] = "DEBUG";
    SystemFeatureToggle["SERVICEFEATUREPACK"] = "SERVICEFEATUREPACK";
    SystemFeatureToggle["HISTORYFEATUREPACK"] = "HISTORYFEATUREPACK";
    SystemFeatureToggle["METRICS"] = "METRICS";
    SystemFeatureToggle["DEVICES"] = "DEVICES";
    SystemFeatureToggle["BETA"] = "BETA";
})(SystemFeatureToggle || (SystemFeatureToggle = {}));
;
export default SystemFeatureToggle;
